import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=07a56a27&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=07a56a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a56a27",
  null
  
)

export default component.exports